export default __webpack_public_path__ + "static/banner_back-9438582214c6bdb4ea001953fcdd79a2.webp";